import React, { useState, useEffect, useMemo } from 'react';
import {
  Grid,
  Card,
  CardContent,
  Box,
  Tabs,
  Tab,
  Pagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@mui/material';
import { saveAs } from 'file-saver';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteVendorRequest,
  resetVendorState,
  fetchAllVendorsRequest,
} from '../../redux/Vendors/actions/vendorActions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../styles/UserStyles.css';
import ReusableTable from '../../component/ui/ReusableTable';
import SearchAndButtonTab from '../../component/ui/SearchAndButtonTab';
import nodata from '../../assets/nodata.jpg';
import {
  ADD_VENDOR,
  VIEW_VENDOR,
} from '../../component/common/Routes/AppRoutes';
import { customHeaders } from './CustomHeaders';
import { vendorColumnFetcher } from '../../Style';
import Loading from '../../component/ui/Loading';
import CustomButton from '../../component/ui/FormFields/Button';

const VendorManagementList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchColumn, setSearchColumn] = useState('vendor_serial_no');
  const [searchQuery, setSearchQuery] = useState('');
  const [tabIndex, setTabIndex] = useState(0);
  const [page, setPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [vendorToDelete, setVendorToDelete] = useState(null);
  const rowsPerPage = 5;

  const {
    vendors: response,
    vendorDetails,
    error,
  } = useSelector((state) => state.vendors);

  const vendors = response?.data || [];
  const deleteLoading = vendorDetails?.deleteLoading;

  const viewListLoading = response?.loading;

  const deleteMessage = useSelector(
    (state) => state.vendors?.vendorDetails?.success
  );

  useEffect(() => {
    if (deleteMessage) {
      toast.success('Vendor Deleted Successfully', {
        position: 'top-center',
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: false,
        onClose: () => {
          dispatch(resetVendorState());
          dispatch(fetchAllVendorsRequest());
        },
      });
    }
  }, [deleteMessage]);
  useEffect(() => {
    dispatch(resetVendorState());
    dispatch(fetchAllVendorsRequest());
  }, [dispatch, page]);

  const handleExport = () => {
    if (!vendors.length) return;

    const csvHeaders = [
      'First Name,Last Name,Agency Name,Email,Phone,Address1,Address2,City,State,Country,Pincode,IATA Reg Number,Vendor Commission,Pan Number,Gstin Number,Status,Approove Status',
    ];

    const csvRows = vendors.map((vendor) => {
      const escapeCsvField = (field) => {
        if (field === null || field === undefined) return '""';
        const stringField = String(field || '-');
        if (
          stringField.includes(',') ||
          stringField.includes('"') ||
          stringField.includes('\n')
        ) {
          return `"${stringField.replace(/"/g, '""')}"`;
        }
        return stringField;
      };

      return [
        escapeCsvField(vendor.first_name),
        escapeCsvField(vendor.last_name),
        escapeCsvField(vendor.agency_name),
        escapeCsvField(vendor.email),
        escapeCsvField(vendor.phone),
        escapeCsvField(vendor.address1),
        escapeCsvField(vendor.address2),
        escapeCsvField(vendor.city_name),
        escapeCsvField(vendor.state_name),
        escapeCsvField(vendor.country_name),
        escapeCsvField(vendor.pincode),
        escapeCsvField(vendor.iata_reg_no),
        escapeCsvField(vendor.discount),
        escapeCsvField(vendor.pan_number),
        escapeCsvField(vendor.gstin_number),
        escapeCsvField(vendor.status === 0 ? 'Active' : 'Inactive'),
        escapeCsvField(
          vendor.approove_status === 1
            ? 'Approved'
            : vendor.approove_status === 2
            ? 'Pending'
            : 'Rejected'
        ),
      ].join(',');
    });

    const csvContent = [csvHeaders, ...csvRows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'vendors.csv');
  };

  const handleOpenPopup = (vendor) => {
    setVendorToDelete(vendor);
    setOpen(true);
  };

  const handleClosePopup = () => {
    setVendorToDelete(null);
    setOpen(false);
  };
  const handleConfirmDelete = async () => {
    await dispatch(deleteVendorRequest(vendorToDelete.id));

    handleClosePopup();
  };
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
    setPage(1);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };
  console.log('vendor', vendors);
  const filteredVendors = useMemo(() => {
    const transformedVendors = vendors.map((vendor) => ({
      vendorId: vendor.vendor_serial_no || '-',
      // id: vendor.id,
      vendorName: vendor.agency_name || '-',
      email: vendor.email || '-',
      mobile: vendor.phone || '-',
      gstin: vendor.gstin_number || '-',
      // createdDate: vendor.created_at || "-",
      // lastActive: vendor?.last_active !== null ? vendor?.last_active : "-",
      // approvalStatus:
      //   vendor.approove_status === 1
      //     ? "Approved"
      //     : vendor.approove_status === 2
      //     ? "Pending"
      //     : "Rejected" || "-",
      // vendorStatus: vendor.status === 0 ? "Active" : "Inactive" || "-"
    }));

    if (!searchQuery) {
      return transformedVendors;
    }

    return transformedVendors.filter((vendor) => {
      if (vendor[searchColumn]) {
        return vendor[searchColumn]
          .toString()
          .toLowerCase()
          .includes(searchQuery.toLowerCase());
      }
      return false;
    });
  }, [vendors, searchQuery, searchColumn]);

  const filteredVendorByStatus = useMemo(() => {
    const statusFiltered =
      tabIndex === 0
        ? vendors.filter((vendor) => vendor.approove_status === 2)
        : tabIndex === 1
        ? vendors.filter((vendor) => vendor.approove_status === 1)
        : vendors.filter((vendor) => vendor.approove_status === 3);

    return statusFiltered.filter((vendor) => {
      if (!searchQuery) return true;
      const transformedVendor = {
        vendorId: vendor.vendor_serial_no,
        vendorName: vendor.agency_name,
        email: vendor.email,
        mobile: vendor.phone,
        gstin: vendor.gstin_number,
        // createdDate: vendor.created_at,
        // lastActive: vendor?.last_active !== null ? vendor?.last_active : "-",
        // approvalStatus:
        //   vendor.approove_status === 1
        //     ? "Approved"
        //     : vendor.approove_status === 2
        //     ? "Pending"
        //     : "Rejected",
        // vendorStatus: vendor.status === 0 ? "Active" : "Inactive"
      };

      return transformedVendor[searchColumn]
        ?.toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
    });
  }, [vendors, tabIndex, searchQuery, searchColumn]);

  const paginatedData = useMemo(() => {
    return filteredVendorByStatus.slice(
      (page - 1) * rowsPerPage,
      page * rowsPerPage
    );
  }, [filteredVendorByStatus, page, rowsPerPage]);
  const columns = useMemo(
    () =>
      filteredVendors.length > 0
        ? vendorColumnFetcher(filteredVendors)
        : [[], []],
    [filteredVendors]
  );

  if (viewListLoading) {
    return <Loading text='Loading Vendor details...' />;
  }

  return (
    <>
      <ToastContainer />
      <Box className='container'>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <SearchAndButtonTab
                  title='Vendors'
                  columns={columns}
                  searchColumn={searchColumn}
                  setSearchColumn={setSearchColumn}
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                  handleExport={handleExport}
                  routeName={ADD_VENDOR}
                  type='vendor'
                />
                <Tabs
                  value={tabIndex}
                  onChange={handleTabChange}
                  indicatorColor='primary'
                  textColor='primary'
                  sx={{ marginBottom: '30px', gap: 5 }}
                >
                  <Tab label='Pending' />
                  <Tab label='Approved' />
                  <Tab label='Rejected' />
                </Tabs>

                {error ? (
                  <Box textAlign='center' py={5}>
                    <p>
                      Error:{' '}
                      {typeof error === 'string'
                        ? error
                        : error?.message || 'An error occurred'}
                    </p>
                  </Box>
                ) : (
                  <>
                    {paginatedData.length > 0 && (
                      <ReusableTable
                        data={paginatedData}
                        headers={customHeaders}
                        navigate={navigate}
                        paginatedData={paginatedData}
                        handleView={(vendor) => {
                          navigate(
                            `${VIEW_VENDOR.replace(':vendorId', vendor.id)}`,
                            { state: { vendorDetails: vendor } }
                          );
                        }}
                        handleEdit={(vendor) =>
                          navigate(`/vendors/edit/${vendor.id}`)
                        }
                        handleOpenPopup={handleOpenPopup}
                      />
                    )}
                    {
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: '100%',
                        }}
                      >
                        {paginatedData.length === 0 && (
                          <img
                            src={nodata}
                            alt='nodata'
                            style={{ maxWidth: '300px', maxHeight: '300px' }}
                          />
                        )}
                      </div>

                      // <Box sx={{ textAlign: "center", padding: 2 }}>
                      //   <Typography sx={{ color: "red" }}>
                      //     No records available.
                      //   </Typography>
                      // </Box>
                    }

                    <Box className='button-box'>
                      {filteredVendorByStatus.length > 0 && (
                        <Pagination
                          count={Math.ceil(
                            filteredVendorByStatus.length / rowsPerPage
                          )}
                          page={page}
                          onChange={handlePageChange}
                          color='primary'
                        />
                      )}
                    </Box>
                  </>
                )}
              </CardContent>
            </Card>
          </Grid>
          <Dialog open={open} onClose={handleClosePopup}>
            <DialogTitle>Confirm Delete</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to delete{' '}
                <strong>{vendorToDelete?.agency_name}</strong>?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                size='small'
                onClick={handleClosePopup}
                className='handle-back'
              >
                Cancel
              </Button>
              <CustomButton
                variant='contained'
                className='handle-delete'
                type='button'
                size='small'
                loading={deleteLoading}
                text={'DELETE'}
                onClick={() => handleConfirmDelete()}
              />
            </DialogActions>
          </Dialog>
        </Grid>
      </Box>
    </>
  );
};

export default VendorManagementList;
